/* ../lib/components/parts/Help/Help.svelte generated by Svelte v3.18.2 */
import {
	SvelteComponent,
	append,
	attr,
	detach,
	element,
	init,
	insert,
	listen,
	noop,
	safe_not_equal,
	space
} from "svelte/internal";

import { createEventDispatcher } from "svelte";
import octocat from "../../../images/octocat.svg";

function add_css() {
	var style = element("style");
	style.id = "svelte-ak69m4-style";
	style.textContent = ".overlay.svelte-ak69m4.svelte-ak69m4{display:block;position:fixed;top:0;left:0;width:100%;height:100%;background-color:rgba(0, 0, 0, 0.4)}section.svelte-ak69m4.svelte-ak69m4{position:fixed;top:40px;left:50%;transform:translate(-50%, 0);width:80%;min-height:300px;background:white;padding:16px;border-radius:10px}h1.svelte-ak69m4.svelte-ak69m4{padding:16px;margin:-16px -16px 16px;border-bottom:1px solid #ccc}ul.svelte-ak69m4.svelte-ak69m4{display:grid;grid-row-gap:8px;line-height:1;color:#333}li.svelte-ak69m4.svelte-ak69m4{display:grid;grid-template-columns:auto 1fr;grid-column-gap:10px}kbd.svelte-ak69m4.svelte-ak69m4{display:inline-block;padding:3px 5px;font:11px 'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, Courier,\r\n      monospace;line-height:10px;color:#444d56;vertical-align:middle;background-color:#fafbfc;border:solid 1px #d1d5da;border-bottom-color:#c6cbd1;border-radius:3px;box-shadow:inset 0 -1px 0 #c6cbd1}footer.svelte-ak69m4 a.svelte-ak69m4{display:inline-block;position:absolute;right:10px;bottom:10px;width:80px;height:80px}";
	append(document.head, style);
}

function create_fragment(ctx) {
	let div;
	let t0;
	let section;
	let h1;
	let t2;
	let ul;
	let t24;
	let footer;
	let a;
	let img;
	let img_src_value;
	let dispose;

	return {
		c() {
			div = element("div");
			t0 = space();
			section = element("section");
			h1 = element("h1");
			h1.textContent = "Keyboard Shortcuts";
			t2 = space();
			ul = element("ul");

			ul.innerHTML = `<li class="svelte-ak69m4"><kbd class="svelte-ak69m4">?</kbd> 
      <span>Open this window.</span></li> 
    <li class="svelte-ak69m4"><kbd class="svelte-ak69m4">Esc</kbd> 
      <span>Close this window.</span></li> 
    <li class="svelte-ak69m4"><span><kbd class="svelte-ak69m4">1</kbd>
        -
        <kbd class="svelte-ak69m4">8</kbd></span> 
      <span>Fold [1 - 8] depth tree node.</span></li> 
    <li class="svelte-ak69m4"><kbd class="svelte-ak69m4">9</kbd> 
      <span>Fold all tree node.</span></li> 
    <li class="svelte-ak69m4"><kbd class="svelte-ak69m4">0</kbd> 
      <span>Unfold all tree node.</span></li>`;

			t24 = space();
			footer = element("footer");
			a = element("a");
			img = element("img");
			attr(div, "class", "overlay svelte-ak69m4");
			attr(h1, "class", "svelte-ak69m4");
			attr(ul, "class", "svelte-ak69m4");
			if (img.src !== (img_src_value = octocat)) attr(img, "src", img_src_value);
			attr(img, "alt", "");
			attr(a, "href", "https://github.com/ampcpmgp/am-mocktimes");
			attr(a, "target", "_blank");
			attr(a, "class", "svelte-ak69m4");
			attr(footer, "class", "svelte-ak69m4");
			attr(section, "class", "svelte-ak69m4");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			insert(target, t0, anchor);
			insert(target, section, anchor);
			append(section, h1);
			append(section, t2);
			append(section, ul);
			append(section, t24);
			append(section, footer);
			append(footer, a);
			append(a, img);
			dispose = listen(div, "click", /*onOverlayClick*/ ctx[0]);
		},
		p: noop,
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) detach(div);
			if (detaching) detach(t0);
			if (detaching) detach(section);
			dispose();
		}
	};
}

function instance($$self) {
	const dispatch = createEventDispatcher();

	function onOverlayClick() {
		dispatch("overlayclick");
	}

	return [onOverlayClick];
}

class Help extends SvelteComponent {
	constructor(options) {
		super();
		if (!document.getElementById("svelte-ak69m4-style")) add_css();
		init(this, options, instance, create_fragment, safe_not_equal, {});
	}
}

export default Help;